import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { finalize, catchError, tap } from 'rxjs/operators';

import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private toastrService: ToastrService,
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err) => {
        let error = err.error || err.errors;
        if (error instanceof Blob) {
          error['text']().then(v => {
            try {
              const errorValue = JSON.parse(v);
              this.toastrService.error(errorValue.message);
            } catch {
              this.toastrService.error(v);
            }
          })
        } else {
          this.toastrService.error(error);
        }
        return throwError(error);
      })
    );
  }

}
